var map = {
	"./arrow-24.svg": 5819,
	"./avatar-24.svg": 3257,
	"./chevron-24.svg": 117,
	"./cross-24.svg": 6134,
	"./external-link-24.svg": 2164,
	"./eye-24.svg": 3031,
	"./facebook-24.svg": 1728,
	"./instagram-24.svg": 42,
	"./linkedin-24.svg": 350,
	"./mailto-24.svg": 9746,
	"./menu-24.svg": 2159,
	"./pinterest-24.svg": 976,
	"./plus-24.svg": 152,
	"./success-24.svg": 5685,
	"./tiktok-24.svg": 9586,
	"./trashcan-24.svg": 4604,
	"./upload-24.svg": 9949,
	"./web-24.svg": 7460,
	"./x-24.svg": 9670,
	"./xing-24.svg": 6880,
	"./youtube-24.svg": 9747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4418;